import { render } from "./Files.vue?vue&type=template&id=7072d5ee"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__